module.exports = __webpack_public_path__ + "static/img/ninja-can-19.8ab980d2.png";